<template>
  <section class="page-wrap">
    <!-- 输入框 start -->
    <div class="input-wrap">
      <el-input
        v-model="sheetOrder"
        placeholder="请在此输入或扫描供货单编码"
        ref="refSheetOrder"
        autofocus="true"
        @keyup.enter.native="onHandleSearch"
      >
        <el-button
          slot="suffix"
          type="primary"
          size="mini"
          :disabled="searchdisabled"
          icon="el-icon-search"
          @click="onHandleSearch"
          >确定</el-button
        >
      </el-input>
    </div>
    <!-- 输入框 end -->
<div>
  <el-button
        
          type="primary"
          
     
          @click="binding"
          >{{windowName?`已经绑定：${windowName}打印机器,模版${template_type==1?'横版：80*50':'竖版：50*80'}`:'绑定标签机'}}</el-button
        >
  <el-button
        
          type="primary"
          v-if="windowName"
     
          @click="qxbinding"
          >取消绑定</el-button
        >
</div>
    <!-- 供货单布局 start -->
    <div v-if="isShowInfo" class="table-wrap" v-loading="loading">
      <div class="sheet-info">
        <div class="sheet-info__header">
          供货单号：{{ formData.supplierOrder }}
        </div>
        <div class="sheet-info__body">
          <!-- <div class="print__count" v-if="formData.print_ed_num">
            {{ `打印次数：${formData.print_ed_num}次` }}
          </div> -->
          <div class="info-one">供货日期：{{ formData.supplierDate }}</div>
          <div class="info-two">
            <div>供货商名称：{{ formData.supplierTitle }}</div>
            <div>联系人：{{ formData.supplierName }}</div>
            <div>联系电话：{{ formData.supplierMobile }}</div>
          </div>
          <div class="info-three">
            <div>SKU数量：{{ formData.sku }}</div>
            <div>总件数：{{ formData.productTotal }}件</div>
          </div>
          <div class="print">
            <div class="btn" @click="onHandlePrint">打印全部标签</div>
          </div>
        </div>
      </div>
      <div class="table-content">
        <table-list
          :tableData="tableData"
          :is_print_member_no="formData.is_print_member_no"
          @on-handle-print="onHandlePrint"
          @handleEdit="handleEdit"
        ></table-list>
      </div>
    </div>
    <!-- 供货单布局 end -->

    <!-- 缺省 start -->
    <c-empty-page v-else tip="请扫描或输入供货单编号~"></c-empty-page>
    <!-- 缺省 end -->

    <!-- 打印窗口 start -->
    <b-select-windows
      ref="refBSelectWindows"
      @on-change-print-windows="onChangePrintWindows"
      @on-change-print-windows-binding="onChangePrintWindowsBinding"
      @on-print-windows="onPrintWindowsBinding"
    ></b-select-windows>
    <!-- 打印窗口 end -->

    <!-- 打印份数弹窗 start -->
    <print-count-dialog ref="refPrintCountDialog"></print-count-dialog>
    <!-- 打印份数弹窗 end -->
  </section>
</template>

<script>
import TableList from "./modules/table-list";
import CEmptyPage from "@/components/common/CEmptyPage";
import BSelectWindows from "@/components/business/BSelectWindows";
import PrintCountDialog from "./modules/print-count-dialog/index.vue";
import {
  getGoodsSheetInfo,
  postPrintBatchOfOrder,
  postPrintBatchOfOrderNew,
  labeldetailprint,
  
} from "@/api/sheet-to-review/index";

export default {
  name: "LogisticsTagPrint",
  data() {
    return {
      loading: false,
      // 供货单编号
      sheetOrder: "",
      windowId: "", // 打印窗口
      template_type: "", // 打印窗口
      // 供货单详情
      formData: {
        supplierOrder: "",
        supplierDate: "",
        supplierTitle: "",
        supplierName: "",
        supplierMobile: "",
        sku: "",
        productTotal: "",
        print_ed_num: "", // 打印次数
        is_print_member_no: "",   
      },
      tableData: [],
      // 是否展示打印详情
      isShowInfo: false,
      windowName:'',
      searchdisabled:false
    };
  },
  components: {
    TableList,
    CEmptyPage,
    BSelectWindows,
    PrintCountDialog,
  },
  mounted() {
    // this.onHandleSearch();
    // this.$refs.refBSelectWindows.onInitData();
    this.$refs.refSheetOrder.focus();
    if(sessionStorage.getItem('windowPrint')){
      let obj=JSON.parse(sessionStorage.getItem('windowPrint'))
      this.windowId=obj.windowId;
      this.template_type=obj.template_type;
      this.windowName=obj.windowName;
    }
  },
  methods: {
    binding(){
this.$refs.refBSelectWindows.onBinding(this.windowId,1);
    },
    qxbinding(){
   this.$confirm("是否确认取消绑定？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
        this.windowId='';
      this.template_type='';
      this.windowName='';
      sessionStorage.removeItem('windowPrint')
        })
        .catch(() => {});
    },
    /**
     * 查询供货单相关
     */
    async onHandleSearch() {
      if (!this.sheetOrder) {
        this.$message.error("请扫描或输入供货单编号~");
        return;
      }
      this.searchdisabled=true;
      this.loading = true;
      const params = {
        supplierOrderNo: this.sheetOrder,
      };
      this.$refs.refSheetOrder.blur();
      try {
        const { data } = await getGoodsSheetInfo(params);
        const {
          supplier_order_no: supplierOrder,
          date: supplierDate,
          supplier_title: supplierTitle,
          supplier_fullname: supplierName,
          supplier_mobile: supplierMobile,
          sku,
          product_total_number: productTotal,
          print_ed_num,
          list,
          is_print_member_no
        } = data;
        this.sheetOrder = "";
        this.formData = {
          supplierOrder,
          supplierDate,
          supplierTitle,
          supplierName,
          supplierMobile,
          print_ed_num,
          sku,
          productTotal,
          is_print_member_no
        };
        this.tableData = list;
        this.isShowInfo = true;
        //l连接打印机器直接
        if(this.windowId){
           this.ajaxPostPrintBatchOfOrder();
        }
        console.log("ajax getGoodsSheetInfo", this.formData);
      } catch (err) {
        console.log("ajax getGoodsSheetInfo err", err);
      } finally {
        this.loading = false;
        this.searchdisabled=false;
      }
    },
    /**
     * 获取打印窗口
     */
    onChangePrintWindowsBinding(data) {
      this.windowId = data.windowId;
      this.template_type = data.template_type;
      this.windowName = data.windowName;
      let obj={
        windowId:data.windowId,
        template_type:data.template_type,
        windowName:data.windowName
      }
    sessionStorage.setItem('windowPrint',JSON.stringify(obj))
    },
    /**
     * 获取打印窗口
     */
    onChangePrintWindows(data) {
      this.windowId = data.windowId;
      this.template_type = data.template_type;
      this.windowName = data.windowName;
      let obj={
        windowId:data.windowId,
        template_type:data.template_type,
        windowName:data.windowName
      }
    sessionStorage.setItem('windowPrint',JSON.stringify(obj))
      const prePageParams = data.prePageParams;
      if (this.isShowInfo) {
        this.onHandlePrint(prePageParams);
      } else {
        this.$refs.refSheetOrder.focus();
      }
    },
    onPrintWindowsBinding(data){
this.windowId = data.windowId;
      this.windowName = data.windowName;
      let obj={
        windowId:data.windowId,
        windowName:data.windowName
      }
    sessionStorage.setItem('windowPrint',JSON.stringify(obj));
    this.handleEdit(this.handleEditpbj);
    },
    /**
     * 打印标签
     */
    onHandlePrint(data) {
      console.log("🆒 ajax onHandlePrint data", data);
      /** 未选择窗口 */
      if (!this.windowId) {
        this.$refs.refBSelectWindows.onInitData(data,'',1);
        return;
      }
      // 单个标签打印
      if (data.sku_code) {
        const params = {
          ...data,
          supplierOrder: this.formData.supplierOrder,
          windowId: this.windowId,
          template_type: this.template_type,
          is_print_member_no:this.formData.is_print_member_no
        };
        this.$refs.refPrintCountDialog.onHandleSubmit(params);
      } else {



              this.$confirm("是否要打印全部标签?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
           // 全部标签打印
        this.ajaxPostPrintBatchOfOrder();
        })
        .catch(() => {});

      
      }
    },
    /**
     * 打印全部标签
     */
    async handleEdit(e) {
this.handleEditpbj=e;
  if (!this.windowId) {
        this.$refs.refBSelectWindows.onInitData(e,1,1);
        return;
      }

      try {
        const params = {
        ...e,
          window_id: this.windowId,
          supplier_order_no:this.formData.supplierOrder,
          template_type: this.template_type,
        };
        const { data } = await labeldetailprint(params);
        console.log("ajax labeldetailprint data", data);
        this.$message.success("打印成功");
      } catch (err) {
        console.log("ajax labeldetailprint err", err);
      }
    },
    /**
     * 打印全部标签
     */
    async ajaxPostPrintBatchOfOrder() {
      try {
        const params = {
          supplier_order_no: this.formData.supplierOrder,
          window_id: this.windowId,
          template_type: this.template_type,
        };
        if(this.formData.is_print_member_no==1){

  const { data } = await postPrintBatchOfOrderNew(params);
        console.log("ajax postPrintBatchOfOrderNew data", data);
        this.$message.success("打印成功");
        }else{
            const { data } = await postPrintBatchOfOrder(params);
        console.log("ajax postPrintBatchOfOrder data", data);
        this.$message.success("打印成功");
        }
      
      } catch (err) {
        console.log("ajax postPrintBatchOfOrder err", err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  height: 100%;
  padding: 6px;
  box-sizing: border-box;
  .input-wrap {
    padding-bottom: 6px;
    /deep/ .el-input {
      position: relative;
      &__inner {
        font-size: 16px;
        height: 45px;
        line-height: 45px;
        &::placeholder {
          // font-size: 18px;
          padding-left: 10px;
        }
      }
      &__suffix {
        top: 5px;
        right: 20px;
      }
    }
    /deep/ .el-button {
      padding: 0 15px;
      height: 34px;
      .el-icon-search {
        font-size: 12px;
      }
      span {
        font-size: 14px;
      }
    }
  }
  .table-wrap {
    height: calc(100% - 90px);
    padding: 20px;
    box-sizing: border-box;
    background: #fff;
    .table-content {
      // max-height: 790px;
      height: calc(100% - 270px);
      overflow: auto;
    }
  }
  .sheet-info {
    &__header {
      padding-bottom: 20px;
      text-align: center;
      font-size: 22px;
      color: #333333;
    }
    &__body {
      font-size: 20px;
      .info-one {
        line-height: 35px;
        font-weight: 600;
      }
      .info-two,
      .info-three {
        display: flex;
        gap: 60px;
        line-height: 40px;
      }
      .print {
        padding-top: 20px;
        padding-bottom: 25px;
        .btn {
          padding: 8px 12px;
          cursor: pointer;
          border-radius: 4px;
          display: inline-block;
          font-size: 15px;
          color: #fff;
          background-color: #13AE67;
        }
      }
      .print__count {
        margin-bottom: 20px;
        font-size: 32px;
        font-weight: 600;
        color: $danger-color;
      }
    }
  }
}
</style>
